/** The slice of the tRPC client this needs: just the sign-in mutation. */
interface RecordSignInClient {
	user: { recordSignIn: { mutate: () => Promise<unknown> } };
}

/**
 * Records the completed login against the caller's account.
 *
 * Bookkeeping, not authentication: the user is already signed in by the time
 * this runs, so a failure is swallowed rather than costing them the session
 * they just established. The next login records it instead.
 *
 * @param trpcClient - The tRPC client to record through.
 */
export async function recordSignIn(trpcClient: RecordSignInClient): Promise<void> {
	try {
		await trpcClient.user.recordSignIn.mutate();
	} catch {
		// Intentionally ignored — see above.
	}
}
